export default __webpack_public_path__ + "844b55c7d4d5fb48eb1964acd4792397.png";